module.exports = __webpack_public_path__ + "static/media/eos.d431754f.svg";